import { AccountDealFragment, OrderType } from 'graphql/bindings/AdminBindings'
import { Typography } from '@forgeglobal/design-framework'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import React, { Fragment } from 'react'
import numeral from 'numeral'
import sum from 'lodash/sum'

export const TransactionHistoryRollup: React.FC<{ deals: AccountDealFragment[] }> = ({ deals }) => {
  const numDeals = (orderType: OrderType) => {
    const filteredDeals = deals.filter(deal => deal.orderType === orderType)
    return filteredDeals.length
  }

  const totalDealVolume = sum(deals.map(deal => deal.totalBuySideVolume + deal.totalSellSideVolume))
  const totalDealRevenue = sum(deals.map(deal => deal.totalBuySideRevenue + deal.totalSellSideRevenue))
  const avgTakeRate = totalDealVolume > 0 ? totalDealRevenue / totalDealVolume : undefined
  const numBuySideDeals = numDeals(OrderType.Bid)
  const numSellSideDeals = numDeals(OrderType.Ask)
  return (
    <Fragment>
      <Typography variant="body1" align="right">
        {numBuySideDeals} buy-side {numBuySideDeals === 1 ? 'deal' : 'deals'} completed
      </Typography>
      <Typography variant="body1" align="right">
        {numSellSideDeals} sell-side {numSellSideDeals === 1 ? 'deal' : 'deals'} completed
      </Typography>
      {totalDealVolume > 0 && (
        <Fragment>
          <Typography variant="body1" align="right">
            {`${formatAbbreviatedMoney(totalDealVolume)} total volume`}
          </Typography>
          <Typography variant="body1" align="right">
            {`${formatAbbreviatedMoney(totalDealRevenue)} net revenue`}
          </Typography>
        </Fragment>
      )}
      {avgTakeRate && (
        <Typography variant="body1" align="right">
          {numeral(avgTakeRate).format('0.[00]%')} average take rate
        </Typography>
      )}
    </Fragment>
  )
}
